import React from 'react';
import { Platform, StyleSheet, TextInput, View } from 'react-native';
import I18n from '../../../components/shared/i18n/I18n.component';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import ButtonV2 from '../../../components/shared/Buttons/ButtonV2.container';
import colors from '../../../config/colors';
import { i18nService } from '../../../services/i18n.service';

interface IdStepProps {
	idNumber: string;
	setIdNumber: (val: string) => void;
	onContinue: () => void;
	errorKey: string | null;
	loading: boolean;
}

export const IdStep = ({
	idNumber,
	setIdNumber,
	onContinue,
	errorKey,
	loading,
}: IdStepProps) => {
	const updateId = (value: string) => {
		setIdNumber(value.trim());
	};

	const handlerKeyEnter = (e: any) => {
		if (e.nativeEvent.key === 'Enter') {
			onContinue();
		}
	};

	return (
		<>
			<I18n
				size={17}
				font='medium'
				color='primaryDarkBlue'
				style={styles.title}
			>
				signInV2.welcome.title
			</I18n>
			<I18n size={14} style={styles.subtitle} color='subDarkBlue'>
				signInV2.welcome.subtitle
			</I18n>
			{Platform.OS !== 'web' && (
				<TextInput
					autoComplete='current-password'
					secureTextEntry
					pointerEvents='none'
					style={styles.hiddenPassword}
				/>
			)}
			<View
				style={[
					styles.inputContainer,
					errorKey ? styles.errorInput : {},
				]}
			>
				<TextInput
					style={styles.textInput}
					underlineColorAndroid='transparent'
					placeholder={i18nService.translate('signInV2.id.placeholder')}
					value={idNumber}
					onChangeText={updateId}
					onKeyPress={handlerKeyEnter}
					autoComplete='username'
					textContentType='username'
				/>
				<ImageIcon name={'idBadge'} width={18} height={18} />
			</View>
			<View style={styles.errorText}>
				{!!errorKey && (
					<View style={{ flexDirection: 'row-reverse', alignItems: 'center' }}>
						<ImageIcon name={'alertCircle'} color={colors.failure} width={15} height={15} style={{ marginLeft: 4 }} />
						<I18n color='failure' weight='normal' size={12}>
							{errorKey}
						</I18n>
					</View>
				)}
			</View>
			<ButtonV2
				preset='primary'
				size='medium'
				//disabled={idNumber.length < 5 || loading}
				onPress={onContinue}
				overrideStyle={{ width: '100%' }}
			>
				<I18n size={15} weight='normal' color='white' style={styles.continueText}>
					signInV2.continue
				</I18n>
			</ButtonV2>
		</>
	);
};

const styles = StyleSheet.create({
	title: {
		textAlign: 'center',
		marginBottom: 32,
		letterSpacing: 0.15,
	},
	continueText: {
		letterSpacing: 0.25,
	},
	subtitle: {
		textAlign: 'right',
		marginBottom: 12,
	},
	inputContainer: {
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		paddingHorizontal: 16,
		paddingVertical: 10,
		borderRadius: 8,
		borderWidth: 1,
		borderColor: colors.clockGreyText,
		marginBottom: 8,

	},
	textInput: {
		textAlign: 'right',
		fontSize: 14,
		flex: 1,
		width: '384px',
		height: '100%',
		fontWeight: '500',
		letterSpacing: 0.25,
		color: colors.primaryDarkBlue,
		...Platform.select({
			web: {
				outlineWidth: 0,
				outlineStyle: 'none',
			},
		}),
	},
	errorInput: {
		borderColor: colors.failure,
	},
	hiddenPassword: {
		position: 'absolute',
		opacity: 0,
	},
	errorText: {
		marginBottom: 32,
	},
});
